import type { SVGProps } from "react";

/**
 * audio, music, playlist, musical-note
 * @category Sound & Music
 */
export default function IconAudio(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M9.75 18.7501C9.75 20.1308 8.40685 21.2501 6.75 21.2501C5.09315 21.2501 3.75 20.1308 3.75 18.7501C3.75 17.3693 5.09315 16.2501 6.75 16.2501C8.40685 16.2501 9.75 17.3693 9.75 18.7501ZM9.75 18.7501V7.25874C9.75 6.36574 10.342 5.58095 11.2007 5.33567L17.7029 3.47828C18.9805 3.11333 20.2522 4.07265 20.2522 5.40136V15.7501M20.2522 15.7501C20.2522 17.1308 18.9091 18.2501 17.2522 18.2501C15.5953 18.2501 14.2522 17.1308 14.2522 15.7501C14.2522 14.3693 15.5953 13.2501 17.2522 13.2501C18.9091 13.2501 20.2522 14.3693 20.2522 15.7501Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    </svg>
  );
}
